module.exports = __webpack_public_path__ + "static/media/deep.05506f1b.jpg";